export default {"src":"/uk/_next/static/media/spot-chat.338cee01.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};